module.exports = "<p>\n  lisans almanız gerekiyor.. \n</p>\n"